import { render, staticRenderFns } from "./Consulenti.vue?vue&type=template&id=1aa02772&scoped=true&"
import script from "./Consulenti.vue?vue&type=script&lang=js&"
export * from "./Consulenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa02772",
  null
  
)

export default component.exports